// extracted by mini-css-extract-plugin
module.exports = {"container":"Favorites_container__1sGQy","live":"Favorites_live__h7ww-","content":"Favorites_content__26tX2"};